import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import { IQueryParams } from 'src/types';

import { ICommission, ICommissionData } from './types';

export const fetchCommissionsRequest = async (commissionType: string, { id, ...params }: IQueryParams): Promise<ICommissionData | null> => {
  try {
    const res = await axios.get(`api/v1/${commissionType}/form-views/${id}/commissions`, { params });
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch commissions");
    return null;
  }
};

export const createCommissionsRequest = async (
  commissionType: string,
  id: string,
  data: Partial<ICommission>,
): Promise<ICommission | undefined> => {
  try {
    const res = await axios.post(`api/v1/${commissionType}/form-views/${id}/commissions`, data);
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't create commissions");
    return;
  }
};

export const updateCommissionsRequest = async (
  commissionType: string,
  id: string,
  { id: comissionId, identity, ...data }: Partial<ICommission>,
): Promise<ICommission | undefined> => {
  try {
    const res = await axios.put(`api/v1/${commissionType}/form-views/${id}/commissions/${comissionId}`, data);
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't update commissions");
    return;
  }
};

export const deleteCommissionsRequest = async (commissionType: string, id: string, commissionId: number): Promise<void> => {
  try {
    return await axios.delete(`api/v1/${commissionType}/form-views/${id}/commissions/${commissionId}`);
  } catch (error) {
    NotificationManager.error("Can't delete commissions");
  }
};
